/* ==========================================================
   KARACHI COSMETOLOGY COMPANY — KCC CLINICAL CONSULTANT WIDGET
   Self-contained IIFE — Guaranteed CSS Override & Responsive Fix
   ========================================================== */
(function () {
  'use strict';

/* ── CSS — High Specificity Idempotent Injection ──────── */
if (!document.getElementById('cb-styles')) {
  var style = document.createElement('style');
  style.id = 'cb-styles';
  style.textContent = [
    ':root{--cb-sage:#2F6B66;--cb-dark:#152221;--cb-mint:#C8E6D5;--cb-light:#F5F8F7;}',
    '#cb-widget, #cb-widget *{box-sizing:border-box !important;margin:0;padding:0;}',
    '#cb-widget{position:fixed !important;bottom:24px !important;right:24px !important;z-index:2147483647 !important;font-family:"Plus Jakarta Sans",system-ui,-apple-system,sans-serif !important;}',
    '#cb-fab{width:60px !important;height:60px !important;border-radius:50% !important;background:var(--cb-sage) !important;color:#fff !important;border:none !important;cursor:pointer !important;box-shadow:0 8px 28px rgba(47,107,102,.45) !important;display:flex !important;align-items:center !important;justify-content:center !important;font-size:1.5rem !important;transition:transform .3s ease,box-shadow .3s ease !important;position:relative !important;}',
    '#cb-fab:hover{transform:scale(1.08) !important;box-shadow:0 12px 36px rgba(47,107,102,.55) !important;}',
    '#cb-badge{position:absolute !important;top:2px !important;right:2px !important;width:14px !important;height:14px !important;border-radius:50% !important;background:#e63946 !important;border:2px solid #fff !important;display:none !important;}',
    '#cb-window{width:380px !important;height:540px !important;max-height:85vh !important;background:#fff !important;border-radius:20px !important;box-shadow:0 20px 60px rgba(0,0,0,.22) !important;display:flex !important;flex-direction:column !important;overflow:hidden !important;position:absolute !important;bottom:74px !important;right:0 !important;transform:scale(.85) translateY(20px) !important;opacity:0 !important;pointer-events:none !important;transform-origin:bottom right !important;transition:all .3s cubic-bezier(.16,1,.3,1) !important;}',
    '#cb-window.open{transform:scale(1) translateY(0) !important;opacity:1 !important;pointer-events:auto !important;}',
    '#cb-header{background:var(--cb-dark) !important;padding:14px 18px !important;display:flex !important;align-items:center !important;gap:12px !important;flex-shrink:0 !important;}',
    '#cb-header-seal{width:38px !important;height:38px !important;border-radius:50% !important;background:var(--cb-sage) !important;color:#fff !important;font-size:.82rem !important;font-weight:700 !important;display:flex !important;align-items:center !important;justify-content:center !important;flex-shrink:0 !important;letter-spacing:1px !important;}',
    '#cb-header-info{flex:1 !important;overflow:hidden !important;}',
    '#cb-header-name{color:#fff !important;font-size:.92rem !important;font-weight:700 !important;white-space:nowrap !important;overflow:hidden !important;text-overflow:ellipsis !important;}',
    '#cb-header-status{color:var(--cb-mint) !important;font-size:.72rem !important;display:flex !important;align-items:center !important;gap:6px !important;margin-top:2px !important;}',
    '#cb-header-dot{width:7px !important;height:7px !important;border-radius:50% !important;background:#4caf50 !important;flex-shrink:0 !important;}',
    '#cb-close{background:none !important;border:none !important;color:rgba(255,255,255,.6) !important;cursor:pointer !important;font-size:1.2rem !important;transition:color .2s !important;padding:4px !important;display:flex !important;align-items:center !important;justify-content:center !important;}',
    '#cb-close:hover{color:#fff !important;}',
    '#cb-messages{flex:1 !important;overflow-y:auto !important;padding:16px !important;display:flex !important;flex-direction:column !important;gap:16px !important;background:#f9fbfa !important;scrollbar-width:thin;scrollbar-color:rgba(47,107,102,.2) transparent;}',
    '#cb-messages::-webkit-scrollbar{width:4px;}#cb-messages::-webkit-scrollbar-thumb{background:rgba(47,107,102,.2);border-radius:2px;}',
    
    /* Message Structure */
    '.cb-row-bot{display:flex !important;align-items:flex-start !important;gap:10px !important;width:100% !important;}',
    '.cb-row-user{display:flex !important;justify-content:flex-end !important;width:100% !important;}',
    '.cb-avatar{width:32px !important;height:32px !important;border-radius:50% !important;background:var(--cb-sage) !important;color:#fff !important;font-size:.7rem !important;font-weight:700 !important;display:flex !important;align-items:center !important;justify-content:center !important;flex-shrink:0 !important;margin-top:2px !important;letter-spacing:0.5px !important;}',
    '.cb-msg-container{display:flex !important;flex-direction:column !important;align-items:flex-start !important;max-width:calc(100% - 42px) !important;}',
    '.cb-bubble-bot{background:var(--cb-light) !important;border:1px solid rgba(47,107,102,.14) !important;color:#1A2928 !important;padding:12px 15px !important;border-radius:16px 16px 16px 4px !important;font-size:.85rem !important;line-height:1.55 !important;word-break:break-word !important;white-space:pre-wrap !important;width:100% !important;}',
    '.cb-bubble-user{background:var(--cb-sage) !important;color:#fff !important;padding:12px 15px !important;border-radius:16px 16px 4px 16px !important;font-size:.85rem !important;line-height:1.55 !important;max-width:265px !important;word-break:break-word !important;white-space:pre-wrap !important;}',
    '.cb-time{font-size:.62rem !important;color:#88a3a0 !important;margin-top:4px !important;width:100% !important;text-align:right !important;}',
    
    /* Quick Buttons */
    '.cb-qr-wrapper{display:flex !important;flex-wrap:wrap !important;gap:8px !important;margin-top:10px !important;width:100% !important;}',
    '#cb-widget button.cb-qbtn{all:unset !important;box-sizing:border-box !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;background:#eef7f6 !important;border:1.5px solid #c2dedc !important;color:var(--cb-sage) !important;border-radius:50px !important;padding:8px 16px !important;font-size:0.78rem !important;font-weight:600 !important;line-height:1.3 !important;letter-spacing:0.01em !important;text-transform:none !important;cursor:pointer !important;font-family:"Plus Jakarta Sans",system-ui,sans-serif !important;text-align:center !important;white-space:nowrap !important;height:auto !important;min-height:34px !important;width:auto !important;box-shadow:0 2px 6px rgba(0,0,0,0.02) !important;transition:all .2s ease !important;}',
    '#cb-widget button.cb-qbtn:hover{background:var(--cb-sage) !important;color:#ffffff !important;border-color:var(--cb-sage) !important;transform:translateY(-1px) !important;box-shadow:0 4px 12px rgba(47,107,102,0.25) !important;}',
    
    '.cb-typing{display:flex !important;align-items:center !important;gap:5px !important;padding:10px 14px !important;background:var(--cb-light) !important;border:1px solid rgba(47,107,102,.12) !important;border-radius:16px 16px 16px 4px !important;width:fit-content !important;}',
    '.cb-dot{width:7px !important;height:7px !important;border-radius:50% !important;background:#8aada9 !important;animation:cb-bounce .9s infinite !important;}',
    '.cb-dot:nth-child(2){animation-delay:.15s !important;}.cb-dot:nth-child(3){animation-delay:.3s !important;}',
    '@keyframes cb-bounce{0%,60%,100%{transform:translateY(0)}30%{transform:translateY(-6px)}}',
    '#cb-input-area{padding:12px 14px !important;border-top:1px solid rgba(47,107,102,.1) !important;display:flex !important;gap:10px !important;align-items:center !important;background:#fff !important;flex-shrink:0 !important;width:100% !important;}',
    '#cb-input{flex:1 !important;min-width:0 !important;border:1.5px solid rgba(47,107,102,.18) !important;border-radius:999px !important;padding:10px 16px !important;font-size:.85rem !important;font-family:inherit !important;outline:none !important;color:#1A2928 !important;transition:border-color .2s !important;}',
    '#cb-input:focus{border-color:var(--cb-sage) !important;}',
    '#cb-send{width:38px !important;height:38px !important;min-width:38px !important;min-height:38px !important;border-radius:50% !important;background:var(--cb-sage) !important;border:none !important;color:#fff !important;cursor:pointer !important;font-size:1rem !important;display:flex !important;align-items:center !important;justify-content:center !important;transition:background .2s !important;flex-shrink:0 !important;}',
    '#cb-send:hover{background:#214F4B !important;}',
    '#cb-send:disabled{opacity:.5 !important;cursor:not-allowed !important;}',
    
    /* Reliable Mobile Fix: Jab window.open ho toh FAB button automatic hide ho jaye */
    '@media(max-width:520px){',
    '   #cb-widget{bottom:0 !important;right:0 !important;left:0 !important;width:100% !important;}',
    '   #cb-window.open ~ #cb-fab, #cb-window.open + #cb-fab{display:none !important;}',
    '   #cb-window.open{display:flex !important;}',
    '   #cb-fab{bottom:16px !important;right:16px !important;position:fixed !important;z-index:2147483647 !important;}',
    '   #cb-window{width:100% !important;max-width:100vw !important;border-radius:20px 20px 0 0 !important;bottom:0 !important;right:0 !important;left:0 !important;height:85dvh !important;max-height:85vh !important;position:fixed !important;}',
    '   .cb-bubble-bot{max-width:82vw !important;}',
    '   .cb-bubble-user{max-width:82vw !important;}',
    '}'
  ].join('\n');
  document.head.appendChild(style);
}

  /* ── LIVE SHOPIFY STORE PRODUCTS FETCHER (With Discount & Compare-at Price Support) ── */
  function fetchLiveShopifyPrices() {
    return fetch('/products.json')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (!data || !data.products || data.products.length === 0) return null;
        var text = "Live Pricing Overview:\n\n";
        data.products.slice(0, 8).forEach(function(prod) {
          if (prod.variants && prod.variants[0]) {
            var v = prod.variants[0];
            var price = v.price;
            var comparePrice = v.compare_at_price;
            
            text += "💚 " + prod.title + " — ";
            // Agar compare_at_price mojood hai aur price se zyada hai, toh iska matlab discount laga hua hai
            if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
              text += "~~PKR " + comparePrice + "~~ **PKR " + price + " (Sale!)**\n";
            } else {
              text += "PKR " + price + "\n";
            }
          }
        });
        return text;
      })
      .catch(function() {
        return null;
      });
  }

  /* ── KNOWLEDGE BASE — Clinical Human-like English Responses ────── */
  var KB = [
    {
      id: 'greet',
      patterns: ['hello', 'hi', 'salam', 'assalam', 'hey', 'good morning', 'good evening', 'good afternoon', 'greetings'],
      response: 'Welcome to Karachi Cosmetology Company! ✨\n\nI am your KCC Clinical Consultant. I can assist you with:\n\n• Clinical formulations & active ingredients\n• Customized routines for your skin concern\n• Orders, express shipping & easy returns\n• Consultations with Dr. Seema\n\nHow may I guide your skin health journey today?',
      qr: ['Browse Formulations', 'Identify Skin Concern', 'Track Order', 'About Dr. Seema', 'Contact Us']
    },
    {
      id: 'products',
      patterns: ['product', 'shop', 'buy', 'formulation', 'serum', 'cream', 'cleanser', 'oil', 'sunscreen', 'skincare', 'moisturizer', 'moisturiser', 'toner'],
      response: 'Explore our dermatologist-certified clinical formulations available on our store. You can browse all items directly on our shop page!',
      qr: ['View All Products', 'Best Sellers', 'New Arrivals', 'Skin Concern Guide']
    },
    {
      id: 'acne',
      patterns: ['acne', 'breakout', 'pimple', 'blackhead', 'whitehead', 'pore', 'blemish', 'zit', 'spots'],
      response: 'For acne-prone and congested skin, Dr. Seema recommends this clinical protocol:\n\n🌿 Morning: Calming Cleanser → Vitamin C → Hydrating Gel → SPF 50+\n🌙 Evening: Double Cleanse → Cellular Renewal Serum → Barrier Cream\n\nKey Actives: Salicylic Acid 2%, Niacinamide 10%, & Zinc PCA.\n\nNoticeable reduction in breakouts within 28 days of consistent use.',
      qr: ['Shop Acne Care', 'Acne Routine Guide', 'Book Consultation']
    },
    {
      id: 'pigmentation',
      patterns: ['pigmentation', 'dark spot', 'melasma', 'uneven', 'hyperpigmentation', 'dull', 'brightening', 'whitening', 'tone', 'spot', 'mark'],
      response: 'Hyperpigmentation requires targeted clinical brightenings. Dr. Seema advises:\n\n✨ Morning Hero: Vitamin C Luminous Concentrate (15% Pure L-Ascorbic Acid)\n✨ Evening Support: Cellular Renewal Serum with Alpha Arbutin & Niacinamide\n\n💡 Clinical Note: Daily application of broad-spectrum SPF 50+ is essential to prevent pigment recurrence.',
      qr: ['Shop Brightening', 'Full Pigment Routine', 'Sunscreen Advice']
    },
    {
      id: 'dryskin',
      patterns: ['dry', 'dehydrat', 'flak', 'tight', 'moisture', 'hydration', 'barrier', 'ceramide', 'rough', 'peel'],
      response: 'To restore compromised moisture barriers and dry skin:\n\n💧 Deep Moisture Barrier Cream — 72-Hr Ceramide NP + Multi-Hyaluronic Acid\n💧 Radiant Glow Barrier Elixir — Squalane & Botanical Extracts\n\n💡 Application Tip: Apply Hyaluronic Acid on damp skin and seal with moisturizer to lock in deep hydration.',
      qr: ['Shop Hydration', 'Barrier Repair Routine']
    },
    {
      id: 'oilyskin',
      patterns: ['oily', 'shine', 'shiny', 'greasy', 'pore', 'sebum', 'congestion', 'large pore'],
      response: 'For oil control without stripping natural skin moisture:\n\n🍃 Calming Gentle Cleanser — BHA-infused micro-exfoliant\n🍃 Cellular Renewal Serum — Niacinamide 10% for sebum balance\n\n💡 Clinical Rule: Never omit moisturizer; dehydration triggers rebound oil production.',
      qr: ['Shop Oil Control', 'Oily Skin Routine']
    },
    {
      id: 'sensitive',
      patterns: ['sensitive', 'redness', 'rosacea', 'reactive', 'sting', 'flush', 'allerg', 'irritat', 'fragrance'],
      response: 'All Dr. Seema\'s formulations are rigorously tested for hyper-sensitive skin:\n\n🌸 Deep Moisture Barrier Cream — Infused with Centella Asiatica, 100% fragrance-free\n🌸 Calming Gentle Cleanser — Colloidal Oat & Allantoin\n\n💡 Always use 100% Mineral Zinc Oxide Sunscreen to avoid stinging.',
      qr: ['Shop Sensitive Line', 'Patch Test Protocol']
    },
    {
      id: 'aging',
      patterns: ['aging', 'anti aging', 'wrinkle', 'fine line', 'firm', 'elasticit', 'collagen', 'peptide', 'retinol', 'crow', 'forehead line'],
      response: 'Dr. Seema\'s anti-aging & elasticity protocol:\n\n⏳ Cellular Renewal Serum — Bio-Retinol & Quad-Peptide Complex\n⏳ Firming Peptide Eye Essence — Matrixyl 3000\n\n💡 UV exposure accounts for 80% of premature aging — daily SPF 50+ is mandatory.',
      qr: ['Shop Anti-Aging', 'Anti-Aging Protocol']
    },
    {
      id: 'vitaminc',
      patterns: ['vitamin c', 'vit c', 'ascorbic', 'luminous'],
      response: 'Our Vitamin C Luminous Concentrate is our flagship brightening formulation:\n\n✨ 15% L-Ascorbic Acid + Ferulic Acid + Vitamin E\n✨ Fades dark spots and boosts collagen\n\n💡 Apply 3–4 drops every morning on clean skin prior to SPF application.',
      qr: ['Buy Vitamin C', 'Morning Skincare Steps']
    },
    {
      id: 'shipping',
      patterns: ['shipping', 'delivery', 'dispatch', 'courier', 'tcs', 'how long', 'arrive', 'deliver', 'track', 'when will'],
      response: 'Express Nationwide Delivery Details:\n\n🚚 Standard Courier (3–5 Business Days): PKR 250\n🚀 Express Delivery (1–2 Business Days): PKR 500\n🎁 Complimentary Free Shipping on orders above PKR 12,000!\n\nTracking details are dispatched via SMS & Email immediately upon fulfillment.',
      qr: ['Place an Order', 'Review Shipping Policy']
    },
    {
      id: 'returns',
      patterns: ['return', 'refund', 'exchange', 'money back', 'damage', 'wrong product', 'complaint', 'cancel'],
      response: 'Our Hassle-Free Guarantee:\n\n✅ 7-Day Easy Return Policy for all unopened products\n✅ 100% Instant Refund or Exchange for damaged items\n\n📧 Email Support: support@drseemasproducts.pk\nPlease provide your Order ID and photo verification for immediate processing.',
      qr: ['Contact Support', 'Browse Shop']
    },
    {
      id: 'payment',
      patterns: ['payment', 'pay', 'cash', 'cod', 'cash on delivery', 'visa', 'mastercard', 'online', 'card', 'easypaisa', 'jazzcash', 'paypal'],
      response: 'We offer flexible & 100% secure payment gateways:\n\n💳 Credit / Debit Cards (Visa, Mastercard)\n💰 Cash on Delivery (Nationwide Pakistan)\n📱 PayPal, Apple Pay & Google Pay\n\nAll digital transactions are 256-bit SSL encrypted.',
      qr: ['Proceed to Checkout', 'Shipping Information']
    },
    {
      id: 'about',
      patterns: ['dr seema', 'doctor', 'founder', 'who is', 'about', 'dermatologist', 'qualified', 'certified', 'experience', 'biography'],
      response: 'About Dr. Seema & KCC:\n\n👩‍⚕️ Board-Certified Dermatologist with 30+ years of clinical excellence\n🎓 FCPS Dermatology — CPSP Pakistan\n🏥 Research Fellowship — King\'s College London\n📚 Author of 14 peer-reviewed clinical skincare publications\n\nFounded to bring pharmaceutical-grade, clean skincare to Pakistan.',
      qr: ['Read Biography', 'Book Consultation']
    },
    {
      id: 'consult',
      patterns: ['consult', 'consultation', 'appointment', 'book', 'advice', 'skin test', 'recommend', 'which product', 'what should i use', 'skin analysis'],
      response: 'Connect with KCC\'s Clinical Team:\n\n📱 Virtual Consultation & Skin Analysis\n📋 Tailored 3-Step Routine Builder\n\nTo schedule a consultation:\n📞 Helpline: +92 (042) 3555-SEEMA\n📧 Direct Email: support@drseemasproducts.pk',
      qr: ['Skin Concerns Page', 'Contact Support', 'Routine Builder']
    },
    {
      id: 'contact',
      patterns: ['contact', 'phone', 'email', 'address', 'location', 'whatsapp', 'reach', 'customer', 'support', 'help', 'helpline'],
      response: 'Reach KCC\'s Clinical Team:\n\n📧 Email: support@drseemasproducts.pk\n📞 Helpline: +92 (042) 3555-SEEMA\n📍 Location: DHA PAHSE 6, karachi, Pakistan\n\n⏰ Business Hours: Monday–Saturday, 9:00 AM – 6:00 PM PKT',
      qr: ['Contact Us', 'Book Consultation', 'Read Biography']
    },
    {
      id: 'ingredients',
      patterns: ['ingredient', 'paraben', 'sulfate', 'fragrance', 'organic', 'natural', 'clean', 'safe', 'halal', 'cruelty', 'chemical', 'toxic'],
      response: 'Our Clean Clinical Standard:\n\n🌿 Over 1,400 harmful chemicals strictly excluded\n✅ 0% Parabens, Sulfates, Phthalates, or Synthetic Fragrances\n✅ Leaping Bunny Certified Cruelty-Free\n✅ ISO 22716 GMP Certified Manufacturing',
      qr: ['Shop Clean Skincare', 'Sensitive Skin Safe']
    },
    {
      id: 'spf',
      patterns: ['spf', 'sunscreen', 'sun', 'uv', 'sun protection', 'zinc', 'mineral sunscreen'],
      response: 'Broad-Spectrum UV Protection is fundamental:\n\n☀️ Wear SPF 50+ daily regardless of weather\n☀️ Reapply every 2–3 hours during outdoor exposure\n\nDr. Seema Note: "Sunscreen is the ultimate anti-aging and anti-pigmentation treatment available."',
      qr: ['Shop Sun Protection', 'Pigmentation Guide']
    },
    {
      id: 'price',
      patterns: ['price', 'cost', 'how much', 'expensive', 'affordable', 'discount', 'sale', 'offer', 'promo', 'coupon', 'cheap'],
      response: 'DYNAMIC_PRICES',
      qr: ['Shop Now', 'Go to Cart']
    }
  ];

  /* ── PAGE LINKS — Direct URL Map ─────────────── */
  var PAGE_LINKS = {
    'View All Products': '/shop',
    'Best Sellers': '/shop?filter=bestseller',
    'New Arrivals': '/shop?filter=new',
    'Shop Acne Care': '/collections/skin-concerns',
    'Shop Brightening': '/collections/skin-concerns',
    'Shop Hydration': '/collections/skin-concerns',
    'Shop Oil Control': '/collections/skin-concerns',
    'Shop Sensitive Line': '/collections/skin-concerns',
    'Shop Anti-Aging': '/collections/skin-concerns',
    'Shop Sun Protection': '/collections/skin-concerns',
    'Shop Clean Skincare': '/shop',
    'Sensitive Skin Safe': '/collections/skin-concerns',
    'Shop Now': '/shop',
    'Buy Vitamin C': '/shop',
    'Read Biography': '/pages/about-us',
    'About Dr. Seema': '/pages/about-us',
    'Skin Concerns Page': '/collections/skin-concerns',
    'Identify Skin Concern': '/collections/skin-concerns',
    'Go to Cart': '/cart',
    'Proceed to Checkout': '/cart',
    'Browse Formulations': '/shop',
    'Browse Shop': '/shop',
    'Routine Builder': '/collections/skin-concerns',
    'Contact Us': '/pages/contact-us',
    'Contact Support': '/pages/contact-us'
  };

  /* ── LOCAL KB REPLY MATCHING ──────────────────────────── */
  function getLocalReply(userText) {
    var text = userText.toLowerCase();
    
    if (text.match(/price|cost|how much|rate|kitna/)) {
      return fetchLiveShopifyPrices().then(function(liveText) {
        if (liveText) {
          return { response: liveText, qr: ['Shop Now', 'Go to Cart'] };
        } else {
          return { response: 'Please check our live store products page for up-to-date pricing.', qr: ['Shop Now'] };
        }
      });
    }

    var best = null;
    var bestScore = 0;

    KB.forEach(function (entry) {
      var score = 0;
      entry.patterns.forEach(function (pattern) {
        if (text.includes(pattern)) score++;
      });
      if (score > bestScore) {
        bestScore = score;
        best = entry;
      }
    });

    if (best) {
      return Promise.resolve({ response: best.response, qr: best.qr });
    }

    /* Professional English Fallback */
    return Promise.resolve({
      response: 'Thank you for your message. I am here to assist you with any skincare inquiries. You can ask me about:\n\n• Clinical formulations & active ingredients\n• Tailored routines for your specific skin concern\n• Orders, shipping & easy returns\n• Consultations with Dr. Seema\n\nAlternatively, feel free to reach our clinical support team directly at support@drseemasproducts.pk.',
      qr: ['Browse Formulations', 'Identify Skin Concern', 'About Dr. Seema', 'Contact Us']
    });
  }

  function getReply(userText) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        getLocalReply(userText).then(resolve);
      }, 350);
    });
  }

  function getQuickReplies(text) {
    var t = (text || '').toLowerCase();
    if (t.match(/acne|breakout|pimple|pore/)) return ['Shop Acne Care', 'Acne Routine Guide', 'Book Consultation'];
    if (t.match(/pigment|dark spot|melasma|tone/)) return ['Shop Brightening', 'Full Pigment Routine', 'Sunscreen Advice'];
    if (t.match(/dry|dehydrat|flak|moisture/)) return ['Shop Hydration', 'Barrier Repair Routine'];
    if (t.match(/oily|shine|sebum/)) return ['Shop Oil Control', 'Oily Skin Routine'];
    if (t.match(/sensitive|redness|rosacea/)) return ['Shop Sensitive Line', 'Skin Concerns Page'];
    if (t.match(/aging|wrinkle|fine line|peptide/)) return ['Shop Anti-Aging', 'Anti-Aging Protocol'];
    if (t.match(/product|shop|buy|serum|cream/)) return ['View All Products', 'Best Sellers', 'New Arrivals'];
    if (t.match(/ship|deliver|order|track/)) return ['Place an Order', 'Review Shipping Policy'];
    if (t.match(/price|cost|coupon|discount/)) return ['Shop Now', 'Go to Cart'];
    if (t.match(/hi|hello|salam|hey/)) return ['Browse Formulations', 'Identify Skin Concern', 'About Dr. Seema'];
    return ['Browse Formulations', 'Skin Concerns Page', 'Contact Us'];
  }

  /* ── DOM STATE & TIMESTAMPS ───────────────────────────── */
  var isOpen = false;

  function getTime() {
    var d = new Date();
    var h = d.getHours(), m = d.getMinutes();
    var ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return h + ':' + (m < 10 ? '0' + m : m) + ' ' + ampm;
  }

  /* ── ADD MESSAGE TO CHAT ──────────────────────────────── */
  function addMessage(text, sender, qrList) {
    var msgs = document.getElementById('cb-messages');
    if (!msgs) return;

    var row = document.createElement('div');
    row.className = sender === 'bot' ? 'cb-row-bot' : 'cb-row-user';

    if (sender === 'bot') {
      var av = document.createElement('div');
      av.className = 'cb-avatar';
      av.textContent = 'KCC';
      row.appendChild(av);

      var msgContainer = document.createElement('div');
      msgContainer.className = 'cb-msg-container';

      var bubble = document.createElement('div');
      bubble.className = 'cb-bubble-bot';
      bubble.textContent = text;
      msgContainer.appendChild(bubble);

      var ts = document.createElement('div');
      ts.className = 'cb-time';
      ts.textContent = getTime();
      msgContainer.appendChild(ts);

      if (qrList && qrList.length) {
        var qrWrapper = document.createElement('div');
        qrWrapper.className = 'cb-qr-wrapper';
        qrList.forEach(function (label) {
          var btn = document.createElement('button');
          btn.className = 'cb-qbtn';
          btn.type = 'button';
          btn.textContent = label;
          btn.addEventListener('click', function () {
            if (PAGE_LINKS[label]) {
              window.location.href = PAGE_LINKS[label];
            } else {
              handleUserInput(label);
            }
          });
          qrWrapper.appendChild(btn);
        });
        msgContainer.appendChild(qrWrapper);
      }

      row.appendChild(msgContainer);
    } else {
      var msgContainer = document.createElement('div');
      msgContainer.className = 'cb-msg-container';
      msgContainer.style.alignItems = 'flex-end';

      var bubble = document.createElement('div');
      bubble.className = 'cb-bubble-user';
      bubble.textContent = text;
      msgContainer.appendChild(bubble);

      var ts = document.createElement('div');
      ts.className = 'cb-time';
      ts.textContent = getTime();
      msgContainer.appendChild(ts);

      row.appendChild(msgContainer);
    }

    msgs.appendChild(row);
    msgs.scrollTop = msgs.scrollHeight;
  }

  /* ── TYPING INDICATOR ─────────────────────────────────── */
  function showTyping() {
    var msgs = document.getElementById('cb-messages');
    if (!msgs) return;
    var row = document.createElement('div');
    row.className = 'cb-row-bot';
    row.id = 'cb-typing-row';

    var av = document.createElement('div');
    av.className = 'cb-avatar';
    av.textContent = 'KCC';
    row.appendChild(av);

    var t = document.createElement('div');
    t.className = 'cb-typing';
    t.innerHTML = '<div class="cb-dot"></div><div class="cb-dot"></div><div class="cb-dot"></div>';
    row.appendChild(t);

    msgs.appendChild(row);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function hideTyping() {
    var el = document.getElementById('cb-typing-row');
    if (el) el.remove();
  }

  /* ── HANDLE USER INPUT ────────────────────────────────── */
  function handleUserInput(text) {
    var trimmed = text.trim();
    if (!trimmed) return;
    var input = document.getElementById('cb-input');
    var sendBtn = document.getElementById('cb-send');
    if (input) { input.value = ''; input.disabled = true; }
    if (sendBtn) sendBtn.disabled = true;

    addMessage(trimmed, 'user');
    showTyping();

    getReply(trimmed).then(function (result) {
      hideTyping();
      addMessage(result.response, 'bot', result.qr || getQuickReplies(trimmed + ' ' + result.response));
      if (input) { input.disabled = false; input.focus(); }
      if (sendBtn) sendBtn.disabled = false;
    });
  }

  /* ── TOGGLE CHAT WINDOW ───────────────────────────────── */
  function toggleChat() {
    isOpen = !isOpen;
    var win = document.getElementById('cb-window');
    var badge = document.getElementById('cb-badge');
    if (!win) return;
    if (isOpen) {
      win.classList.add('open');
      if (badge) badge.style.display = 'none';
      setTimeout(function () {
        var inp = document.getElementById('cb-input');
        if (inp) inp.focus();
      }, 320);
    } else {
      win.classList.remove('open');
    }
  }

  /* ── CREATE WIDGET DOM ────────────────────────────────── */
  function createWidget() {
    var widget = document.createElement('div');
    widget.id = 'cb-widget';

    var win = document.createElement('div');
    win.id = 'cb-window';
    win.setAttribute('role', 'dialog');
    win.setAttribute('aria-modal', 'true');
    win.setAttribute('aria-label', 'KCC Clinical Consultant');

    win.innerHTML = `
      <div id="cb-header">
        <div id="cb-header-seal">KCC</div>
        <div id="cb-header-info">
          <div id="cb-header-name">KCC Clinical Consultant</div>
          <div id="cb-header-status"><span id="cb-header-dot"></span> Online — Dermatology Expert</div>
        </div>
        <button id="cb-close" aria-label="Close chat" title="Close">&#10005;</button>
      </div>
      <div id="cb-messages"></div>
      <div id="cb-input-area">
        <input id="cb-input" type="text" placeholder="Ask about formulations, skin concerns..." autocomplete="off" maxlength="200">
        <button id="cb-send" aria-label="Send message" title="Send">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
        </button>
      </div>
    `;

    var fab = document.createElement('button');
    fab.id = 'cb-fab';
    fab.setAttribute('aria-label', 'Open chat');
    fab.setAttribute('title', 'Chat with KCC Clinical Consultant');
    fab.innerHTML = `
      <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
      </svg>
      <span id="cb-badge"></span>
    `;

    widget.appendChild(win);
    widget.appendChild(fab);
    document.body.appendChild(widget);

    fab.addEventListener('click', toggleChat);

    document.getElementById('cb-close').addEventListener('click', function () {
      if (isOpen) toggleChat();
    });

    document.getElementById('cb-send').addEventListener('click', function () {
      var inp = document.getElementById('cb-input');
      if (inp) handleUserInput(inp.value);
    });

    document.getElementById('cb-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleUserInput(this.value);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) toggleChat();
    });
  }

  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    var w = document.getElementById('cb-widget');
    if (w && !w.contains(e.target)) toggleChat();
  });

  function init() {
    createWidget();

    setTimeout(function () {
      showTyping();
      setTimeout(function () {
        hideTyping();
        addMessage(
          'Welcome to Karachi Cosmetology Company. ✨\n\nI am your dedicated KCC Clinical Consultant. Whether you need assistance choosing the right formulation, building a daily routine, or tracking an order, I am here to help. How may I guide you today?',
          'bot',
          ['Browse Formulations', 'Identify Skin Concern', 'About Dr. Seema', 'Contact Us']
        );
        var badge = document.getElementById('cb-badge');
        if (badge && !isOpen) {
          badge.style.cssText = 'display:block !important;position:absolute !important;top:2px !important;right:2px !important;width:14px !important;height:14px !important;border-radius:50% !important;background:#e63946 !important;border:2px solid #fff !important;';
        }
      }, 1000);
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();